/**
 * @name: filters.js
 * @description: 常用过滤器
 * @author: 温永江
 * @create: 2020/07/22 14:18:39
 * @update: 2020/07/22 14:18:39
 */

import Vue from 'vue';
import formatDate from './formatDate';
import currency from './currency';
import yuan from './yuan';
import * as dictionary from './dictionary';

const date = (v) => {
  const { year, month, day } = formatDate(v);
  if (year) return `${year}-${month}-${day}`;
};
const datetime = (v) => {
  const {
    year, month, day, hours, minutes, seconds
  } = formatDate(v);
  if (year) return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

// 人民币大写
Vue.filter('yuan', (v) => yuan(v));

// 注册字典类过滤器
Object.keys(dictionary).forEach((key) => {
  Vue.filter(key, (v) => dictionary[key][v]);
});

// 千位分隔过滤器
Vue.filter('currency', (v) => currency(v));
// 时间过滤
Vue.filter('date', (v, type = 'YYYY-MM-DD') => date(v));
Vue.filter('datetime', (v, type = 'YYYY-MM-DD HH:mm:ss') => datetime(v));

Vue.filters = Vue.prototype.$filters = {
  yuan: (v) => yuan(v),
  currency: (v) => currency(v),
  date: (v, type = 'YYYY-MM-DD') => date(v),
  datetime: (v, type = 'YYYY-MM-DD HH:mm:ss') => datetime(v)
};
